import { Link, TextStyle } from '@superops/ui-design-system';
import React from 'react';
import { SVGIcon } from '@superops/super-icons';

function AssetLinkCell(props) {
  const { cell, iconType } = props;

  const { original: asset } = cell?.row || {};

  const { actions } = cell?.column || {};

  const imageMap = {
    1: iconType === 'dark' ? 'WindowsDark' : 'Windows',
    2: iconType === 'dark' ? 'LinuxLineIcon' : 'LinuxIcon',
    3: iconType === 'dark' ? 'MacDark' : 'Mac',
    4: 'PrinterLight',
    5: 'RouterLight',
    6: 'SwitchLight',
    7: 'FireWallLight',
    8: 'UPS',
    9: 'LoadBalancer',
    10: 'PowerDevice',
    11: 'Storage',
    12: 'Wan',
    13: 'WireLessAccessPoint',
    14: 'WirelessLanController',
    15: 'Voip',
    16: 'IpCamera',
    17: 'Storage',
    18: 'ServerHardwareController'
  };

  const getIcon = () => {
    return imageMap[asset?.assetClass?.classId || '1'];
  };

  return cell.value ? (
    <div className="ellipsis flex g5">
      <SVGIcon name={getIcon()} />
      <Link
        fontWeight="normal"
        removeUnderline
        onClick={actions?.onClick.bind(this, cell)}
      >
        {cell.value}
      </Link>
    </div>
  ) : (
    <TextStyle disabled>NA</TextStyle>
  );
}

export default AssetLinkCell;
